export default {
  supportedLngs: ["en", "gu"],
  fallbackLng: "en",
  defaultNS: "common",
  react: {
    useSuspense: false,
  },
  ns: ["common"],
  interpolation: {
    escapeValue: false,
  },
};
